<template>
  <svg
    class="mypage-ticket-toggle-icon-parts"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9144 16.293L13.9144 8.29297C13.1333 7.51192 11.867 7.51192 11.0859 8.29297L3.08594 16.293H5.91437L12.5002 9.70718L19.0859 16.293L21.9144 16.293Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MypageTicketToggleIconParts',
})
</script>

<style scoped lang="scss">
.mypage-ticket-toggle-icon-parts {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
